/**
 * https://stackoverflow.com/questions/1410311/regular-expression-for-url-validation-in-javascript
 * regex based on above with few modifications
 *
 * validates most url patterns, a case of good enough. To validate all urls patterns is very difficult
 * (from what I've read) and often leads to valid urls being in correctly validated.
 */
const validateUrl = (url) => {
    const urlRegex = /^(http|https):\/\/[^ "]+\.[^ "]+/;
    const isValid = urlRegex.test(url);
    return isValid;
};

export default validateUrl;
